import styled from '@emotion/styled';

const StyledAnchor = styled.a(
  {
    'display': 'inline-flex',
    'alignItems': 'center',
    '& > svg': {
      marginRight: 5,
      fontSize: 25
    }
  },
  ({ theme }) => ({
    'fontWeight': theme.typography.fontWeightMedium,
    '& > svg': {
      color: theme.palette.colors.columbiaBlue
    },
    'fontSize': theme.typography.fontSize.medium,
    'color': theme.palette.colors.blackCoral
  })
);

export default StyledAnchor;
